import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-panel',
  standalone: false,
  templateUrl: './filter-panel.component.html',
  styleUrl: './filter-panel.component.scss',
})
export class FilterPanelComponent {
  @Input() filters: string[] = [];
  @Input() isPanelVisible: boolean = false;
  @Output() onFilterSelect = new EventEmitter<string>();
  @Output() onTogglePanel = new EventEmitter<boolean>();

  toggleFilterPanel() {
    this.isPanelVisible = !this.isPanelVisible;
    this.onTogglePanel.emit(this.isPanelVisible);
  }

  applySelectedFilter(filter: string) {
    this.onFilterSelect.emit(filter);
    this.toggleFilterPanel();
  }
}
